export const messages = {
  en: {
    integralShopGift: {
      title: 'Points Gift',
      queryCondition: 'Query Conditions',
      query: 'Query',
      id: 'ID',
      rule: 'Rule',
      ruleName: 'Rule Name', 
      quantity: 'Points',
      personId: 'User ID',
      personName: 'User Name',
      tel: 'Phone',
      accountId: 'Account ID',
      accountName: 'Account Name',
      detailId: 'Detail ID',
      remark: 'Remark',
      createTime: 'Create Time',
      personNamePlaceholder: 'Please enter user name',
      telPlaceholder: 'Please enter phone number',
      accountNamePlaceholder: 'Please enter account name'
    }
  },
  zh: {
    integralShopGift: {
      title: '积分赠送',
      queryCondition: '查询条件',
      query: '查询',
      id: '编号',
      rule: '规则',
      ruleName: '规则名称',
      quantity: '积分数量',
      personId: '用户ID',
      personName: '用户名称',
      tel: '手机号',
      accountId: '账户ID',
      accountName: '账户名称',
      detailId: '账户明细ID',
      remark: '备注',
      createTime: '赠送时间',
      personNamePlaceholder: '请输入用户名称',
      telPlaceholder: '请输入手机号',
      accountNamePlaceholder: '请输入账户名称'
    }
  }
}